<script setup>
const props = defineProps({
  area: {
    type: String,
    default: ''
  }
})
const areaName = getJpAreaName(props.area)
const { data: recommendList } = await useFetch('/api/golf/ranking', { query: { limit: '3', area: props.area } })
</script>

<template>
  <section class="golfRecommend">
    <div class="title">
      <CommonSectionTitle :title="`今人気のゴルフ場（${areaName}）`" />
      <p>※約2400地点のゴルフ場のページのアクセス数をはじめ、独自の基準に基づき順位を算出しています。</p>
    </div>
    <div class="block">
      <template
        v-for="(item, rank, index) in recommendList"
        :key="index"
      >
        <GolfRecommendItem
          :content="item"
          :rank="Number(rank)"
        />
      </template>
    </div>
    <div class="button">
      <CommonMoreButton
        text="もっと見る"
        direction="left"
        col="white"
        :link="area ? `/ranking/${area}/` : '/ranking/'"
        type="golf"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.golfRecommend {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .title {
    p {
      font-size: 12px;
      color: #101010;
    }
  }
  .block {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .button {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
